const NUMMAX = {
    numeroSUSEP: 999999999,

    ordem: 100,

    larguraLogoTopbar: 300,
    larguraLogoReport: 280,
    alturaLogoReport: 68,
    alturaLogoTopbar: 60,

    estudoReportCapaTitulo1MargemTopo: 120,
    estudoReportCapaClienteConjugeTitulo2MargemTopo: 190,//150,
    estudoReportCapaClienteConjugeTitulo2MargemEsquerda: 135,

    backgroundPaginaRelatorioMargemEsquerdaCabecalho: 10,
    backgroundPaginaRelatorioMargemTopoRodape: 5,

    margemTop: 250,
    margemLeft: 150,

    diasAntecedenciaEnvioLembreteAporte: 5, // HARDCODEBACKEND.diasAntecedenciaEnvioLembreteAporte

    idade: 150,

    tempoMinimoEntreAportesResgatesCalculoIRAnos: 100,

    qtdeDependentes: 20,

    peso: 500,
    imc: 999,
    qtdeFumoSemanal: 9999,

    perc: 100,

    anosReajusteAumento: 50,

    dia: 31,
    dias: 99999,
    mes: 12,
    ano: 2200,
    meses: 2400,
    anos: 100,

    mesesDevolucaoFundoReserva: 6,
    mesesIniciarAluguelAposContemplacao: 6,
    mesesVendaAposQuitacao: 24,

    anoComissao: 50,
    percComissao: 200,

    anoMes: 220012,
    
    anosExibicaoRelatorioEvolucaoReservaFinanceira: 10,

    cotaConsorcio: 9999,
    numeroAssembleiaParticipacao: 999,
    prazoTotalGrupoConsorcio: 999,
    prazoTotalCotaConsorcio: 999,
    numeroTotalParticipantesGrupoConsorcio: 999,

    percRentabilidadeRecursoFinanceiro: 9999.99,

    taxa: 999.99,
    percIR: 35,

    qtdeParcelas: 9999,
    numeroCobertura: 999999999999999,

    processoSeguradora: 99999999,

    duracaoPremioExtra: 50,

    ultimaVersao: 999,

    qtdeClientes: 9999999,
    qtdeTransacoes: 99999999,
}

export default NUMMAX